module.exports = "/_next/static/images/NoTransaction@3x-8ccd764404ccdbcb65811c35cb0f7455.png";